import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";

import { setPortalProfilesAction as setPortalProfiles, setCustomModulesAction } from "../reducers/portalSetting";

export function getPortalCustomModules() {
  return async (dispatch: any) => {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/portal/customModuleController`);
    if (responseData.data.status) {
      dispatch(setCustomModulesAction(responseData.data.result));
    }
  };
}

export function getPortalProfiles() {
  return async (dispatch: any) => {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/portal/getPortalProfiles`);
    if (responseData.status) {
      dispatch(setPortalProfiles(responseData.data.result));
    }
  };
}
